module.exports = __webpack_public_path__ + "img/user_not_real.96ee6a98.png";